import React from 'react';
import { twilioSessionApi } from '../../redux/Reducers/commonApis';

export default function MessageIcon({ orderId, workerId, subscriptionId, disabled = false }) {
  const [loading, setLoading] = React.useState(false);

  const createTwilioSessionFn = () => {
    setLoading(true);
    const payload = {
      order_id: orderId,
      worker_id: workerId,
      subscription_id: subscriptionId,
    };
    const response = twilioSessionApi(payload);
    response?.then((res) => {
      setLoading(false);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        const phoneNumber = res?.data?.customer_masked_number;
        if (phoneNumber) {
          window.open(`sms:${phoneNumber}`, '_self');
        }
      } else {
        toast.error(res?.messages || 'Something went wrong');
      }
    });
  };
  return (
    <div
      className={
        'border-client-link flex w-9 items-center justify-center rounded-md border p-1 ' +
        (disabled ? 'cursor-not-allowed opacity-50' : '')
      }
      onClick={() => createTwilioSessionFn()}
    >
      {loading ? (
        <svg className='h-6 w-6 animate-spin stroke-gray-500' viewBox='0 0 256 256'>
          <line x1='128' y1='32' x2='128' y2='64' strokeLinecap='round' strokeLinejoin='round' strokeWidth='24'></line>
          <line
            x1='195.9'
            y1='60.1'
            x2='173.3'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='224'
            y1='128'
            x2='192'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='195.9'
            x2='173.3'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='128'
            y1='224'
            x2='128'
            y2='192'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='195.9'
            x2='82.7'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line x1='32' y1='128' x2='64' y2='128' strokeLinecap='round' strokeLinejoin='round' strokeWidth='24'></line>
          <line
            x1='60.1'
            y1='60.1'
            x2='82.7'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth='1.5'
          stroke='currentColor'
          width='24'
          height='24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z'
          />
          {/* Add more spokes to the icon */}
        </svg>
      )}
    </div>
  );
}
